import React, { useState, useEffect } from 'react';
import { Row, Col, Form, Button, Card, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaGlobe, FaTasks } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { updatePreferences } from "../../../redux/slices/userSlice"; 
import { getCurrentUser } from "../../../redux/slices/authSlice";

const NotificationsArea = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.auth.user);
    
    const [isSaving, setIsSaving] = useState(false);

    const [general, setGeneral] = useState({
        time_tracking: false,
        exit: false,
        pop_up_notifications: false
    });

    const [tasks, setTasks] = useState({
        assignment: false,
        changes_made: false,
        comments: false,
        deadline_alert: false
    });

    useEffect(() => {
        if (currentUser && currentUser.preferences) {
            const prefs = currentUser.preferences;
            if (prefs.general) setGeneral(prefs.general);
            if (prefs.tasks) setTasks(prefs.tasks);
        }
    }, [currentUser]);

    const handleGeneralChange = (name) => {
        setGeneral(prev => ({ ...prev, [name]: !prev[name] }));
    };

    const handleTasksChange = (name) => {
        setTasks(prev => ({ ...prev, [name]: !prev[name] }));
    };

    const toggleAllGeneral = (e) => {
        const isChecked = e.target.checked;
        setGeneral({
            time_tracking: isChecked,
            exit: isChecked,
            pop_up_notifications: isChecked
        });
    };

    const toggleAllTasks = (e) => {
        const isChecked = e.target.checked;
        setTasks({
            assignment: isChecked,
            changes_made: isChecked,
            comments: isChecked,
            deadline_alert: isChecked
        });
    };

    const handleSave = async () => {
        setIsSaving(true);
        try {
            await dispatch(updatePreferences({ general, tasks })).unwrap();
            dispatch(getCurrentUser());
        } catch (error) {
            console.error("Erro ao guardar preferências:", error);
        } finally {
            setIsSaving(false);
        }
    };

    const allGeneralChecked = Object.values(general).every(Boolean);
    const allTasksChecked = Object.values(tasks).every(Boolean);

    return (
        <div className="pt-3 pb-5">
            <div className="mb-5">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2" style={{ borderBottom: '2px solid var(--gray-200)' }}>
                    <div className="d-flex align-items-center gap-2">
                        <FaGlobe className="fs-4 txt-subtle" />
                        <h4 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.geral')}</h4>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className="txt-main fw-semibold" style={{ fontSize: '0.9rem' }}>{t('components.NotificationsArea.toggle_all')}</span>
                        <Form.Check type="switch" checked={allGeneralChecked} onChange={toggleAllGeneral} />
                    </div>
                </div>

                <Row className="g-3">
                    <Col md={4}>
                        <Card className="h-100 border-0 p-3" style={{ backgroundColor: 'var(--gray-50)', borderRadius: 'var(--border-radius)' }}>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.registo_ponto')}</h6>
                                <Form.Check type="switch" checked={general.time_tracking} onChange={() => handleGeneralChange('time_tracking')} />
                            </div>
                            <p className="txt-subtle mb-0" style={{ fontSize: '0.85rem' }}>{t('components.NotificationsArea.registo_ponto_desc')}</p>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="h-100 border-0 p-3" style={{ backgroundColor: 'var(--gray-50)', borderRadius: 'var(--border-radius)' }}>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.saida')}</h6>
                                <Form.Check type="switch" checked={general.exit} onChange={() => handleGeneralChange('exit')} />
                            </div>
                            <p className="txt-subtle mb-0" style={{ fontSize: '0.85rem' }}>{t('components.NotificationsArea.saida_desc')}</p>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="h-100 border-0 p-3" style={{ backgroundColor: 'var(--gray-50)', borderRadius: 'var(--border-radius)' }}>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.popups')}</h6>
                                <Form.Check type="switch" checked={general.pop_up_notifications} onChange={() => handleGeneralChange('pop_up_notifications')} />
                            </div>
                            <p className="txt-subtle mb-0" style={{ fontSize: '0.85rem' }}>{t('components.NotificationsArea.popups_desc')}</p>
                        </Card>
                    </Col>
                </Row>
            </div>

            <div className="mb-5">
                <div className="d-flex justify-content-between align-items-center mb-3 pb-2" style={{ borderBottom: '2px solid var(--gray-200)' }}>
                    <div className="d-flex align-items-center gap-2">
                        <FaTasks className="fs-4 txt-subtle" />
                        <h4 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.tarefas')}</h4>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className="txt-main fw-semibold" style={{ fontSize: '0.9rem' }}>{t('components.NotificationsArea.toggle_all')}</span>
                        <Form.Check type="switch" checked={allTasksChecked} onChange={toggleAllTasks} />
                    </div>
                </div>

                <Row className="g-3">
                    <Col md={4}>
                        <Card className="h-100 border-0 p-3" style={{ backgroundColor: 'var(--gray-50)', borderRadius: 'var(--border-radius)' }}>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.atribuicao')}</h6>
                                <Form.Check type="switch" checked={tasks.assignment} onChange={() => handleTasksChange('assignment')} />
                            </div>
                            <p className="txt-subtle mb-0" style={{ fontSize: '0.85rem' }}>{t('components.NotificationsArea.atribuicao_desc')}</p>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="h-100 border-0 p-3" style={{ backgroundColor: 'var(--gray-50)', borderRadius: 'var(--border-radius)' }}>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.alteracoes')}</h6>
                                <Form.Check type="switch" checked={tasks.changes_made} onChange={() => handleTasksChange('changes_made')} />
                            </div>
                            <p className="txt-subtle mb-0" style={{ fontSize: '0.85rem' }}>{t('components.NotificationsArea.alteracoes_desc')}</p>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="h-100 border-0 p-3" style={{ backgroundColor: 'var(--gray-50)', borderRadius: 'var(--border-radius)' }}>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.comentarios')}</h6>
                                <Form.Check type="switch" checked={tasks.comments} onChange={() => handleTasksChange('comments')} />
                            </div>
                            <p className="txt-subtle mb-0" style={{ fontSize: '0.85rem' }}>{t('components.NotificationsArea.comentarios_desc')}</p>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="h-100 border-0 p-3" style={{ backgroundColor: 'var(--gray-50)', borderRadius: 'var(--border-radius)' }}>
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="txt-main fw-bold mb-0">{t('components.NotificationsArea.alerta_limite')}</h6>
                                <Form.Check type="switch" checked={tasks.deadline_alert} onChange={() => handleTasksChange('deadline_alert')} />
                            </div>
                            <p className="txt-subtle mb-0" style={{ fontSize: '0.85rem' }}>{t('components.NotificationsArea.alerta_limite_desc')}</p>
                        </Card>
                    </Col>
                </Row>
            </div>

            <Row>
                <Col className="d-flex justify-content-end mt-4">
                    <Button 
                        variant="primary" 
                        className="rounded-pill" 
                        onClick={handleSave}
                        disabled={isSaving}
                        style={{ minWidth: '100px', minHeight: '40px', padding: '10px 20px' }}
                    >
                        {isSaving ? (
                            <Spinner as="span" animation="border" size="sm" className="me-2" />
                        ) : (
                            t('common.save_changes', 'Guardar Alterações')
                        )}
                    </Button>
                </Col>
            </Row>
        </div>
    );
}

export default NotificationsArea;